
/**
 * Utility functions for handling test titles and descriptions
 */

export const getTableHeadTitle = (selectedTest: string | null): string => {
  if (!selectedTest) return "";

  if (selectedTest === "putts-plat") {
    return "Précision des putts à plat";
  }
  if (selectedTest === "putts-montee") {
    return "Précision des putts en montée";
  }
  if (selectedTest === "putts-descente") {
    return "Précision des putts en descente";
  }
  if (selectedTest === "putts-pente") {
    return "Précision des putts en pente (gauche-droite)";
  }
   if (selectedTest === "putts-pente-droite") {
    return "Précision des putts en pente (droite-gauche)";
  }

  // Tests de chipping
  if (selectedTest === "chipping-plat") {
    return "Précision du chipping sur terrain plat";
  }
  if (selectedTest === "chipping-pente-droit") {
    return "Précision du chipping en pente droite";
  }
  if (selectedTest === "chipping-pente-gauche") {
    return "Précision du chipping en pente gauche";
  }
  if (selectedTest === "chipping-roulee-plat") {
    return "Précision du chipping balle roulée terrain plat";
  }
  if (selectedTest === "chipping-roulee-pente") {
    return "Précision du chipping balle roulée pente droite gauche";
  }
  if (selectedTest === "chipping-roulee-pente-gauche") {
    return "Précision du chipping balle roulée pente gauche droite";
  }

  // Tests de wedging
  if (selectedTest === "wedging-cercles") {
    return "Précision du wedging court";
  }
  if (selectedTest === "wedging-mid") {
    return "Précision du wedging mi-distance";
  }
  if (selectedTest === "wedging-pente-gauche") {
    return "Précision du wedging court en pente gauche droite";
  }
  if (selectedTest === "wedging-pente-droite") {
    return "Précision du wedging court en pente droite gauche";
  }
  if (selectedTest === "wedging-mid-pente-gauche") {
    return "Précision du wedging mi-distance en pente gauche droite";
  }
  if (selectedTest === "wedging-mid-pente-droite") {
    return "Précision du wedging mi-distance en pente droite gauche";
  }
  
  // Tests de bunker
  if (selectedTest === "bunker-court") {
    return "Précision des sorties de bunker court";
  }
  if (selectedTest === "bunker-long") {
    return "Précision des sorties de bunker long";
  }
  
  // Tests de fers
  if (selectedTest === "iron-precision") {
    return "Précision des fers sur le parcours";
  }
  if (selectedTest === "iron-green-attack-100") {
    return "Attaque de green 100 m";
  }
  
  // Tests de bois de parcours
  if (selectedTest === "fairwayWood-precision") {
    return "Précision des bois de parcours";
  }

  return "Tableau des résultats";
};
